<template>
  <div class="view-grade">
    <Header></Header>
    <div class="grade-content max-w">
      <div class="back" @click="$router.push(`/${schoolcode}/student`)">
        返回
      </div>
      <div class="grade-info">
        <div class="all-grade">
          <div class="all-title">总成绩</div>
          <div class="all-num">
            <span>{{ user.total_score }}</span> 分
          </div>
          <div class="all-task">已完成{{ user.total_num }}个任务</div>
        </div>
        <div class="info-content">
          <div class="practice-con">
            <div class="practice-title">
              实践活动名称：{{ activityInfo.name }}
            </div>
            <div class="practice-allnum">
              实践活动总分：{{ activityInfo.total_score }}
            </div>
            <div class="practice-allnum">
              实践任务总数：{{ activityInfo.total_num }}
            </div>
          </div>
          <div class="studen-info">
            <div class="common-info">学生姓名：{{ user.name }}</div>
            <div class="common-info">学员账号：{{ user.username }}</div>
            <div class="common-info">学员班级：{{ user.class_name }}</div>
          </div>
        </div>
      </div>
      <div class="export-con">
        <div class="export-btn" @click="exportGrade()">导出成绩</div>
      </div>
      <div class="grade-table">
        <table>
          <thead>
            <tr>
              <th>实践环节</th>
              <th>实践任务</th>
              <th>总分</th>
              <th>得分</th>
              <th>评分方式</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="item in gradeList">
              <tr :key="ele.id" v-for="(ele, ind) in item.children">
                <template v-if="ind == 0">
                  <td :rowspan="item.children.length" :class="item.children.length > 1 && 'row'">
                    {{ item.name }}
                  </td>
                </template>

                <td>{{ ele.name }}</td>
                <td>{{ ele.score }}</td>
                <td>{{ ele.user_score }}</td>
                <td :class="{teach: ele.approve_status == '教师评分'}">{{ ele.approve_status }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import "../../assets/css/student.less";
import services from "../../assets/js/services.js";
export default {
  components: {
    Header,
  },
  data () {
    return {
      schoolcode: localStorage.getItem("schoolCode"),
      activityId: "",
      gradeList: [],
      activityInfo: {},
      user: {},
      approveStatus: {
        1: "待评",
        2: "系统评分",
        3: "人工评分",
      },
    };
  },
  created () {
    this.activityId = this.$route.query.activity_id;
    this.getTrainScore();
  },
  methods: {
    async getTrainScore () {
      let res = await services.getTrainScore({
        activity_id: this.activityId,
      });
      if (res.code == "0000") {
        this.activityInfo = res.data.activity;
        this.user = res.data.user;
        this.gradeList = this.setTaskList(res.data.task);
      }
    },
    setTaskList (data) {
      let list = data.filter((item) => item.root_id == 0);

      list.forEach((ele) => {
        ele.children = data.filter((item) => item.root_id == ele.id);
      });
      return list;
    },
    exportGrade () {
      window.open(
        `${services.HOST}/api/center/train/score?activity_id=${this.activityId}&act=export`,
        "_self"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.view-grade {
    padding-top: 60px;
    .grade-content {
        padding-top: 16px;
        margin: 0 auto;
        .back {
            width: 80px;
            height: 32px;
            cursor: pointer;
            background: #b84b3c;
            border-radius: 16px;
            font-weight: bold;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
            line-height: 32px;
            &::before {
                content: '<';
                margin-right: 5px;
            }
        }
        .grade-info {
            height: 120px;
            background: #ffffff;
            border: 1px solid #e7eaec;
            display: flex;
            padding-right: 40px;
            margin-top: 16px;
            .all-grade {
                width: 120px;
                // height: 120px;
                background: linear-gradient(90deg, #ffeecd 0%, #fddeda 100%);
                border-radius: 4px;
                position: relative;

                .all-title {
                    width: 62px;
                    height: 26px;
                    background: #b84b3c;
                    border-radius: 4px 0px 14px 0px;
                    line-height: 26px;
                    font-weight: 400;
                    font-size: 14px;
                    text-align: center;
                    color: #f9faff;
                }
                .all-num {
                    color: #2f2626;
                    text-align: center;
                    position: relative;
                    margin-top: 10px;
                    &::after {
                        content: '';
                        display: block;
                        width: 35px;
                        height: 8px;
                        background-image: url('../../assets/image/student/index/grade-line.png');
                        background-size: cover;
                        background-position: center;
                        position: absolute;
                        bottom: -7px;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                    span {
                        font-weight: bold;
                        font-size: 22px;
                        color: #2f2626;
                    }
                }
                .all-task {
                    width: 108px;
                    height: 24px;
                    background: #ffffff;
                    border-radius: 12px;
                    font-weight: 400;
                    line-height: 24px;
                    text-align: center;
                    font-size: 12px;
                    color: #b84b3c;
                    position: absolute;
                    bottom: 6px;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
            .info-content {
                flex: 1;
                margin-left: 40px;

                .practice-con {
                    display: flex;
                    border-bottom: 1px solid #e7eaec;

                    .practice-title {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-weight: bold;
                        font-size: 14px;
                        color: #6f4113;
                        line-height: 60px;
                        margin-right: 85px;
                    }
                    .practice-allnum {
                        font-weight: bold;
                        font-size: 14px;
                        color: #2f2626;
                        line-height: 60px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-right: 85px;
                    }
                }
                .studen-info {
                    display: flex;
                    .common-info {
                        font-weight: 400;
                        font-size: 14px;
                        color: #717479;
                        line-height: 60px;
                        margin-right: 75px;
                    }
                }
            }
        }
        .export-con {
            margin-top: 10px;
            display: flex;
            justify-content: end;
            .export-btn {
                width: 96px;
                height: 32px;
                background: #fff3f2;
                border-radius: 16px;
                border: 1px solid #cc9d9a;
                font-weight: 400;
                font-size: 14px;
                color: #a82822;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
            }
        }
        .grade-table {
            margin-top: 12px;
            table {
                width: 100%;
                thead {
                    tr {
                        height: 36px;
                        background: linear-gradient(
                            90deg,
                            #dfa267 0%,
                            #d2b48c 100%
                        );
                        font-weight: bold;
                        font-size: 14px;
                        color: #ffffff;
                        th {
                            padding: 0 20px;
                        }
                    }
                }
                tbody {
                    tr {
                        &:nth-child(even) {
                            background: #f9f9f9;
                        }
                        &:nth-child(n + 4) {
                            background: #f9f9f9;
                            border-bottom: 1px solid #ecedef;
                        }
                        td {
                            font-weight: 400;
                            font-size: 14px;
                            color: #717479;
                            padding: 0 20px;
                            line-height: 40px;
                            &.row {
                                border-right: 1px solid #ecedef;
                            }
                            &.teach {
                                color: #7b5127;
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>